module.exports = __webpack_public_path__ + "static/media/iconfinder_website_-_male_business_3440841.85be30b9.png";